import { motion } from "framer-motion";
import { Box, Stack } from "@mui/material";
import { Common, Custom } from "components";
import { useNavigationAction } from "hooks";

// icons
import { CloseRounded } from "@mui/icons-material";

type Props = {
  opened: boolean;
  onClose: () => void;
};

export const Sidebar = ({ opened = false, onClose }: Props) => {
  const {
    t,
    theme,
    isAuthenticated,
    user,
    handleNew,
    handleLogin,
    handleProfile,
    handleLogout,
  } = useNavigationAction(onClose);

  return (
    <>
      {opened && (
        <Box
          sx={{
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9999,
            position: "fixed",
            cursor: "pointer",
            backgroundColor: theme.color.overlay.color,
          }}
          onClick={onClose}
        />
      )}

      <Box
        component={motion.div}
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          zIndex: 9999,
          width: "70%",
          maxWidth: 500,
          position: "fixed",
        }}
        initial={{ x: "-100%" }}
        animate={{ x: opened ? 0 : "-100%" }}
        transition={{ type: "tween", duration: 0.3 }}
        drag="x"
        dragElastic={0.1}
        dragConstraints={{ left: 0, right: 0 }}
        onDrag={(event, info) => {
          if (info.offset.x > 0) {
            event.preventDefault();
          }
        }}
        onDragEnd={(event, info) => {
          if (info.offset.x < -50) {
            onClose();
          }
        }}
      >
        {opened && (
          <Stack
            sx={{
              height: 1,
              display: "flex",
              flexDirection: "column",
              padding: theme.spacing.md,
              backgroundColor: theme.color.background.accent,
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Common.Logo key="logo_navbar" />
              <Custom.IconButton
                size="large"
                onClick={onClose}
                foreground={theme.color.font.color}
              >
                <CloseRounded />
              </Custom.IconButton>
            </Stack>

            <Stack
              alignItems="center"
              mt={theme.spacing.xxxl}
              spacing={theme.spacing.md}
            >
              <Custom.Button
                size="small"
                onClick={handleNew}
                sx={{
                  color: theme.color.font.color,
                  fontWeight: theme.font.semiBold,
                }}
              >
                {t.component.common.navbar.start_potluck}
              </Custom.Button>
              {!isAuthenticated && (
                <Custom.Button
                  size="small"
                  onClick={handleLogin}
                  sx={{
                    color: theme.color.font.color,
                    fontWeight: theme.font.semiBold,
                  }}
                >
                  {t.component.common.navbar.sign_in}
                </Custom.Button>
              )}
              {isAuthenticated && (
                <Custom.Button
                  size="small"
                  onClick={handleLogout}
                  sx={{
                    color: theme.color.font.color,
                    fontWeight: theme.font.semiBold,
                  }}
                >
                  {t.component.common.navbar.sign_out}
                </Custom.Button>
              )}
            </Stack>

            <Stack
              mt="auto"
              alignItems="center"
              mb={theme.spacing.md}
              spacing={theme.spacing.xxxl}
            >
              <Common.Social items={["facebook", "instagram", "email"]} />
              <Common.Signature center />
            </Stack>
          </Stack>
        )}
      </Box>
    </>
  );
};
